import React from 'react';
import { Link } from 'gatsby';

import Layout from '../../components/Layout';

import '../../assets/styles/pages/privacy-poilicy.scss';

const GraciasPage = () => {
  return (
    <Layout
      title="Solicitud recibida | ELE Barcelona"
      description="¡Muchas gracias por tu solicitud!"
    >
      <div className="privacy-policy privacy-policy--extended">
        <section className="first-section content">
          <div className="container">
            <div className="wrapper">
              <h1 className="c-title-42" style={{ textAlign: 'left', marginBottom: 40 }}>
                Solicitud recibida
              </h1>
              <div className="section">
                <p className="c-title-20 mb-3">¡Muchas gracias por tu solicitud!</p>
                <p className="c-text-16">
                  Nos pondremos en contacto contigo en breve por email. Por favor, comprueba tu
                  archivo de correo Spam si no recibes nuestra respuesta.
                </p>
                <p className="c-title-16 mt-3">El equipo ELE Barcelona</p>
                <Link to="/" className="c-btn c-btn--red mt-50">
                  Volver a la página de inicio
                </Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    </Layout>
  );
};

export default GraciasPage;
